import { ReactElement } from 'react'
import { useQueryClient } from 'react-query'
import { useFormikContext } from 'formik'
import { Grid, H } from '@farewill/ui'

import { SelectInput } from 'components/form'
import { FuneralBrandId } from 'config/brands'
import { Constants } from 'lib/models/constants'
import { FuneralPlanAttributes } from 'lib/models/funeral-plan'
import { formatUrnOptions } from 'utils/helpers'
import { hasActiveCelebration } from './celebration-helpers'
import { CaseDetailsSectionProps } from './types'

const UrnType = ({
  handleSave,
}: CaseDetailsSectionProps): ReactElement | null => {
  const cache = useQueryClient()
  const constants = cache.getQueryData('constants') as Constants
  const { values } = useFormikContext<FuneralPlanAttributes>()

  if (!hasActiveCelebration(values.items)) return null

  const packageSlug = values.package?.slug
  /** This field is only shown for a plan with an active celebration, so it's
   * always choosing the celebration-priced first urn. */
  const options = formatUrnOptions({
    brandId: values.package?.brandId as FuneralBrandId,
    packageSlug: packageSlug as string,
    urns: constants?.attributes?.urnPrices,
    isFirstUrn: true,
    hasChosenCelebration: true,
  })

  if (options.length === 0) return null

  return (
    <Grid.Item data-testid="change-urn-type">
      <H size="S">Urn</H>
      <Grid style={{ gridAutoFlow: 'row' }}>
        <Grid.Item spanFromL={8}>
          <SelectInput
            label="Change urn type"
            name="urnType"
            options={options}
            handleSave={({ name, value }) =>
              handleSave({ name, value: value as string })
            }
          />
        </Grid.Item>
      </Grid>
    </Grid.Item>
  )
}

export default UrnType
